import { render, staticRenderFns } from "./SvgExample.vue?vue&type=template&id=7fd387a5&scoped=true&"
import script from "./SvgExample.vue?vue&type=script&lang=js&"
export * from "./SvgExample.vue?vue&type=script&lang=js&"
import style0 from "./SvgExample.vue?vue&type=style&index=0&id=7fd387a5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fd387a5",
  null
  
)

export default component.exports